import React, { useState, useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Faq.css';

function FAQ() {
  const [length, setLength] = useState('');
  const [height, setHeight] = useState('');
  const [breadth, setBreadth] = useState('');
  const [volume, setVolume] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: false, mirror: true });
  }, []);

  const calculateVolume = () => {
    if (length && height && breadth) {
      const result = (length * height * breadth) / 5000;
      setVolume(result.toFixed(2));
    } else {
      setVolume(null);
    }
  };

  return (
    <section id="faqs" className="faq-section py-5">
      <div className="container">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="fw-bold text-success">FAQ & Volumetric Weight Calculator</h2>
          <p className="text-muted fs-5">Get quick answers and calculate your shipment's weight instantly.</p>
        </div>

        {/* Volumetric Weight Calculator */}
        <div className="calculator shadow-sm p-4 rounded-4 bg-white mb-5" data-aos="fade-right">
          <h4 className="fw-bold mb-3 text-success">📏 Volumetric Weight Calculator</h4>
          <p className="text-muted">L × H × B / 5000 = Volumetric Weight (in KG)</p>
          <div className="row g-3 mb-3">
            <div className="col-md-4">
              <input type="number" className="form-control" placeholder="Length (cm)" value={length} onChange={(e) => setLength(e.target.value)} />
            </div>
            <div className="col-md-4">
              <input type="number" className="form-control" placeholder="Height (cm)" value={height} onChange={(e) => setHeight(e.target.value)} />
            </div>
            <div className="col-md-4">
              <input type="number" className="form-control" placeholder="Breadth (cm)" value={breadth} onChange={(e) => setBreadth(e.target.value)} />
            </div>
          </div>
          <button onClick={calculateVolume} className="btn btn-success px-4 rounded-pill">
            Calculate
          </button>
          {volume && <h5 className="mt-3 text-success">Volumetric Weight: {volume} KG</h5>}
        </div>

        {/* Q&A Section */}
        <div className="faq-content shadow-sm p-4 rounded-4 bg-light" data-aos="fade-left">
          <h4 className="fw-bold text-success mb-3">💬 What is DDP and DDU?</h4>
          <p className="text-muted">
            In international trade, <strong>DDP</strong> (Delivered Duty Paid) and <strong>DDU</strong> (Delivered Duty Unpaid)
            define who bears customs and import responsibilities.
          </p>
          <ul className="text-muted">
            <li>
              <strong>DDP:</strong> The seller pays for all costs including duties, taxes, and customs clearance to deliver
              goods directly to the buyer’s destination.
            </li>
            <li>
              <strong>DDU:</strong> The seller delivers to the buyer’s country, but the buyer is responsible for paying duties,
              taxes, and customs fees.
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}

export default FAQ;
